import { Navigate, Outlet } from "react-router-dom";
import { Card, LoadingSpinner } from "@vms/ui-web";
import { useAuth } from "../../auth/AuthProvider";
import { useOrgContext } from "../../context/OrgContext";

/** FPZERO-only sections. Org users get a 404-ish "not authorised" card. */
export function FpzeroOnly() {
  const { user } = useAuth();
  if (!user) return null;
  if (!user.isFpzeroAdmin) {
    return (
      <Card className="p-6 max-w-lg mx-auto mt-12">
        <div className="font-semibold text-gray-900 mb-2">Restricted area</div>
        <div className="text-sm text-gray-600">
          This page is reserved for FPZERO administrators.
        </div>
      </Card>
    );
  }
  return <Outlet />;
}

/** Org-scoped routes — verifies the URL's `:slug` resolves to a visible org. */
export function OrgGuard() {
  const { user } = useAuth();
  const { currentOrg, orgs, orgsLoading } = useOrgContext();

  if (!user) return null;
  if (orgsLoading) {
    return (
      <div className="flex justify-center py-16">
        <LoadingSpinner />
      </div>
    );
  }
  if (!currentOrg) {
    // Slug didn't match a visible org. Either the user lost access or the slug is wrong.
    if (orgs.length > 0) return <Navigate to={`/org/${orgs[0].slug}`} replace />;
    return <Navigate to="/" replace />;
  }
  return <Outlet />;
}

/** Venue-scoped routes — verifies `:vslug` resolves to a visible venue. */
export function VenueGuard() {
  const { currentOrg, currentVenue, venuesLoading } = useOrgContext();
  if (!currentOrg) return null;
  if (venuesLoading) {
    return (
      <div className="flex justify-center py-16">
        <LoadingSpinner />
      </div>
    );
  }
  if (!currentVenue) {
    return <Navigate to={`/org/${currentOrg.slug}/venues`} replace />;
  }
  return <Outlet />;
}
